import {useCallback, useEffect} from 'react';

import {hotkeyPressed} from '../../../util/hotkeys';
import {useUndoRedo} from '../hooks/useUndoRedo';
import {useSaveAndCopyActions} from './ViewBarButton';

export const useViewBarKeyboardShortcuts = () => {
  const {undo, redo} = useUndoRedo();
  const {save} = useSaveAndCopyActions();

  const handleWorkspaceUndo = useCallback(
    (e: KeyboardEvent) => {
      if (hotkeyPressed(e, 'undoWorkspaceAction')) {
        undo?.(true);
      }
    },
    [undo]
  );

  const handleWorkspaceRedo = useCallback(
    (e: KeyboardEvent) => {
      if (hotkeyPressed(e, 'redoWorkspaceAction')) {
        redo?.(true);
      }
    },
    [redo]
  );

  const handleWorkspaceSave = useCallback(
    (e: KeyboardEvent) => {
      if (hotkeyPressed(e, 'saveWorkspace')) {
        e.preventDefault();
        save.fn(true);
      }
    },
    [save]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleWorkspaceUndo);
    document.addEventListener('keydown', handleWorkspaceRedo);
    document.addEventListener('keydown', handleWorkspaceSave);
    return () => {
      document.removeEventListener('keydown', handleWorkspaceUndo);
      document.removeEventListener('keydown', handleWorkspaceRedo);
      document.removeEventListener('keydown', handleWorkspaceSave);
    };
  }, [handleWorkspaceUndo, handleWorkspaceRedo, handleWorkspaceSave]);
};
